import styled from 'styled-components';

export const OnboardingMainWrap = styled.section(
    props => `
        width:100%;
        display: flex;
        background-color: ${props.theme.colors.white.base};
        flex-direction: column;
        position: relative;
    `
);
    
export const BackToTopWrap = styled.div(
    props => `
        position: fixed;
        bottom: 4rem;
        right:2rem;
        display: ${props.disabled ? 'flex' : 'none'};
        width:10rem;
        height: 5rem;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    `
);

export const BackToTopInnerWrap = styled.div(
    props => `
        display: flex;
        background-color: #065af3;
        border-radius: 2rem;
        padding: 0.5rem 1rem;
    `
);

export const BackToTopText = styled.a(
    props => `
        font-size: 1.4rem;
        color: #fff;
        font-weight: bold;
    `
)
export const LoyaltyBanner = styled.img(
    props => `
      margin-left: auto;
      margin-right: auto;
      margin-top: -40px;
      display: block;
      width: 100%;
      max-width: 1350px;
      height:auto;
      //cursor:pointer;
      @media only screen and (max-width: 766px){
        margin-top: 20px;
    }
    `
  );
   